import * as React from "react";

import { Combobox } from "@/components/ui/combobox";
import { Label } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * Dropdown — Auswahlfeld mit optionalem Label.
 *
 * Hülle um `<Combobox>` (durchsuchbar, Radio-Punkt, Marken-Fokus) mit der
 * bisherigen API: `options` als `{ value, label }[]`, `onChange(value)`.
 * Neuer Code verwendet direkt `<Combobox>`.
 */
const Dropdown = ({ label, options = [], onChange, className, value, placeholder, disabled }) => (
  <div className="mt-[0.8rem]">
    {label && <Label>{label}</Label>}
    <Combobox
      value={value ?? null}
      options={options}
      onChange={onChange}
      placeholder={placeholder || "Auswählen…"}
      disabled={disabled}
      className={cn(className)}
    />
  </div>
);

export default Dropdown;
